import http from "../http-common";
import md5 from "md5";

const exit = async (token) => {
  return await http
    .delete("/queue/exit", {
      headers: {
        "x-queue-token": token,
      },
    })
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

const evolution = async (token) => {
  return await http
    .get("/queue/evolution", {
      headers: {
        "x-queue-token": token,
      },
    })
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

export default {
  exit,
  evolution,
};
